import { Button } from '@connected/ui/components/button';
import {
    Popout,
    PopoutBody,
    PopoutContent,
    PopoutHeader,
    PopoutTitle,
} from '@connected/ui/components/popout';
import { useStore } from '@tanstack/react-store';
import { useTranslation } from 'react-i18next';

import { confirmerStore, handleConfirm } from '@/stores/confirmer';

// Component
export function Confirmer() {
    const { isOpen, title } = useStore(confirmerStore);
    const { t } = useTranslation('common');

    return (
        <Popout
            open={isOpen}
            onOpenChange={(open) => {
                if (!open) {
                    handleConfirm(false);
                }
            }}
        >
            <PopoutContent className="z-[100]">
                <PopoutHeader>
                    <PopoutTitle>
                        { title }
                    </PopoutTitle>
                </PopoutHeader>
                <PopoutBody className="px-6 py-6">
                    <div className="flex flex-col gap-4">
                        <Button type="button" variant="ghost" onClick={() => handleConfirm(false)}>
                            {t('actions.general.cancel_short')}
                        </Button>
                        <Button type="button" variant="default" onClick={() => handleConfirm(true)}>
                            {t('actions.general.confirm_short')}
                        </Button>
                    </div>
                </PopoutBody>
            </PopoutContent>
        </Popout>
    );
}
